// src/utils/router-helpers.js
import { getCurrentInstance } from "vue"

export function useRoute() {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error("useRoute must be called within a setup function.")
  }
  return instance.proxy.$route
}

export function useRouter() {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error("useRouter must be called within a setup function.")
  }
  return instance.proxy.$router
}
